export default __webpack_public_path__ + "img/op-treatment-plan.f6ab2555.png";